'use strict';

angular.module('schoolLinqApp').directive('validateDuplicateAccountNumber', function () {
	return {
		restrict: 'A',
		require: 'ngModel',
		link: function (scope, element, attrs, ngModel) {
			scope.$watch(attrs.ngModel, function (v) {
				if (v === undefined) {
					return true;
				}

				var arr = null;
				var arr2 = null;

				if (!arr && scope.$parent.newInvoice) {
					arr = scope.$parent.newInvoice.InvoiceAccounts;
				}

				if (!arr && scope.$parent.newPO) {
					arr = scope.$parent.newPO.PurchaseOrderAccounts;
				}

				if (!arr2 && scope.$parent.selectedVersion) {
					arr2 = scope.$parent.selectedVersion.NonEmployeeAccts;
				}

				//scope.$parent.newPO.PurchaseOrderAccounts

				//var numberOfMatches = scope.$parent.newInvoice.InvoiceAccounts.filter(function (account) {
				//    return account.Account.Id === v.Id;
				//}).length;

				var numberOfMatches = 0;
				if (arr) {
					numberOfMatches = arr.filter(function (account) {
						return account.Account.Id === v.Id;
					}).length;
				} else if (arr2) {
					numberOfMatches = arr2.filter(function (obj) {
						return obj.AccountNumber === v;
					}).length;
				}

				var isValid;
				if (numberOfMatches > 1) {
					isValid = false;
				} else {
					isValid = true;
				}

				ngModel.$setValidity('validateDuplicateAccountNumber', isValid);
				return isValid;
			});
		},
	};
});
